import { useContext } from 'react';
import { ToastContext } from '../context/ToastProvider';

function useNotify(): (content: string, type: string) => void {
  const toastContext = useContext(ToastContext);
  return toastContext.notify;
}

export default useNotify;
